// useConfirm.ts
import { useState, useCallback } from "react";

export const useCustomConfirm = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [onConfirm, setOnConfirm] = useState<() => void>(() => {});
  const [message, setMessage] = useState("");
  const [confirmText, setConfirmText] = useState<
    "Confirm" | "Cancel" | "Delete" | "Alert"
  >("Confirm");
  const [onCancel, setOnCancel] = useState<() => void>(() => {});

  const customConfirm = useCallback(
    (
      msg: string,
      onConfirmCallback: () => void,
      onCancelCallback: () => void = () => {},
      confirmTextfn: "Confirm" | "Cancel" | "Delete" | "Alert" = "Confirm"
    ) => {
      setMessage(msg);
      setOnConfirm(() => onConfirmCallback);
      setIsOpen(true);
      setOnCancel(() => onCancelCallback);
      setConfirmText(confirmTextfn);
    },
    []
  );

  const handleCancel = () => {
    onCancel();
    setIsOpen(false);
  };

  const handleConfirm = () => {
    onConfirm();
    setIsOpen(false);
  };

  return {
    isOpen,
    message,
    customConfirm,
    handleCancel,
    handleConfirm,
    confirmText,
  };
};
